import Product from "@services/sdk/models/product";
import Result from "@services/sdk/models/result";
import type { IFelixClient } from "@servicessdk/interfaces";

const useProductsDataProvider = (clientRef: IFelixClient) => {
	const getProducts = async (event = "BUY") => {
		const result = await clientRef.getProducts(event);
		if (!result.isOk()) {
			return result;
		}

		const products = result.getSuccess();

		return Result.Success(
			Product.ConstructList(products.map((product) => product.responseData)),
		);
	};

	return { getProducts };
};

export default useProductsDataProvider;
